export const MAX_NAME_LENGTH = 255;

export const MIXPANEL_CREATE_FROM_FILE_START = 'admin_create_from_file_start';
export const MIXPANEL_CREATE_FROM_FILE_CANCEL = 'admin_create_from_file_cancel';
export const MIXPANEL_CREATE_FROM_FILE_CREATE = 'admin_create_from_file_create';
export const MIXPANEL_CREATE_FROM_FILE_UPLOAD = 'admin_create_from_file_upload';
export const MIXPANEL_CREATE_FROM_FILE_CANCEL_GENERATION = 'admin_create_from_file_cancel_generation';
